import { c as _c } from "react/compiler-runtime";
import type { SourceAccount, RestoreAccount, Account } from '@repo/api-gw-sdk';
import { CloudProviderIndicator } from '@/components/cloudProviderIndicator';
import { getAccountProvider } from '@/utils/accounts';
import { TextDetailsTuple } from '../text/textDetailsTuple';
export const AccountIndicator = t0 => {
  const $ = _c(9);
  const {
    account,
    showCloudIndicator: t1,
    showAccountName: t2,
    showAccountId: t3,
    copyable: t4
  } = t0;
  const showCloudIndicator = t1 === undefined ? true : t1;
  const showAccountName = t2 === undefined ? true : t2;
  const showAccountId = t3 === undefined ? true : t3;
  const copyable = t4 === undefined ? true : t4;
  let t5;
  if ($[0] !== account) {
    t5 = getAccountProvider(account);
    $[0] = account;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const cloudProvider = t5;
  let t6;
  if ($[2] !== account || $[3] !== cloudProvider || $[4] !== copyable || $[5] !== showAccountId || $[6] !== showAccountName || $[7] !== showCloudIndicator) {
    t6 = showCloudIndicator ? <CloudProviderIndicator cloudProvider={cloudProvider} text={<Tuple showAccountName={showAccountName} showAccountId={showAccountId} account={account} copyable={copyable} />} /> : <Tuple showAccountName={showAccountName} showAccountId={showAccountId} account={account} copyable={copyable} />;
    $[2] = account;
    $[3] = cloudProvider;
    $[4] = copyable;
    $[5] = showAccountId;
    $[6] = showAccountName;
    $[7] = showCloudIndicator;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};
const Tuple = t0 => {
  const $ = _c(4);
  const {
    showAccountName,
    showAccountId,
    account,
    copyable: t1
  } = t0;
  const copyable = t1 === undefined ? true : t1;
  const gwsDomain = "restoreAccountAttributes" in account ? account.restoreAccountAttributes.googleWorkspace?.primaryDomain : undefined;
  const t2 = showAccountName ? account.name : undefined;
  const t3 = showAccountId ? gwsDomain || account.providerAccountId : undefined;
  let t4;
  if ($[0] !== copyable || $[1] !== t2 || $[2] !== t3) {
    t4 = <TextDetailsTuple primaryProp={t2} secondaryProp={t3} copyable={copyable} />;
    $[0] = copyable;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
};